import type { UserProfile } from "@/services/authService";

export function isRapidPlan(userProfile: UserProfile | null): boolean {
  const currentPlanTitle = userProfile?.access?.currentPlan?.title
    ?.trim()
    .toLowerCase();

  return currentPlanTitle === "rapid";
}

export function isStarterPlan(userProfile: UserProfile | null): boolean {
  const currentPlanTitle = userProfile?.access?.currentPlan?.title
    ?.trim()
    .toLowerCase();

  return currentPlanTitle === "starter";
}
